import { createContext } from 'react';
import { PolicyHolderType } from '../components/common/CommonTypes';

export type CustomerState = {
    customer: PolicyHolderType;
};

export type CustomerContextState = {
    customer: PolicyHolderType;
    setCustomer: (customer: PolicyHolderType) => void;
};

const initialState: CustomerContextState = {
    customer: undefined,
    setCustomer: undefined
};

export const CustomerContext = createContext(initialState);
